// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  baseUrl: 'https://tah.thealgohopper.com/faq/',
  contBaseUrl: 'https://tah.thealgohopper.com/qcont_api/',
  feedBaseUrl: 'https://tah.thealgohopper.com/qfeed_api/',
  feedSockBaseUrl: 'https://tah.thealgohopper.com/qfeed_sock',
  orderBaseUrl: 'https://tah.thealgohopper.com/qorder_api/',
  reportBaseUrl: 'https://tah.thealgohopper.com/qreport_api/',
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
